import React from 'react';

import styled from '@emotion/styled';
import {
  Backdrop,
  CircularProgress,
  IconButton,
  SvgIcon,
} from '@mui/material';

import {ReactComponent as ChevronLeftSmallOutlined} from 'assets/svg/chevron-left-small-outlined.svg';
import {ReactComponent as ChevronRightSmallOutlined} from 'assets/svg/chevron-right-small-outlined.svg';
import {getI18nLanguage} from 'i18n';


export const CalNavHeader = styled('div')(({theme}) => ({
  flexDirection: 'row',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
}));
export const CalNavButton = styled(IconButton)(({theme}) => ({
  'borderRadius': '8px',
  'height': '1.5rem',
  'width': '1.5rem',
  'color': theme.palette.common.swatch['90'],
  'fontSize': '0.875rem',
  '&.Mui-focusVisible': {
    boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 0px 0px 4px ${theme.palette.primary.swatch['60']}`,
  },
  // style the div els containing svgs
  'div': {
    height: '1rem',
  },
  'svg': {
    height: '1rem',
    width: '1rem',
  },
}));
export const Title = styled('span')(({theme}) => ({
  'left': '18px',
  'position': 'absolute',
}));

/**
 *
 * @param {*} props
 * @return {ReactElement}
 */
export default function CustomHeader({
  decreaseMonth,
  disableNextMonth,
  increaseMonth,
  monthDate,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
}) {
  return (
    <CalNavHeader>
      <Title className="react-datepicker__current-month">
        {monthDate.toLocaleString(getI18nLanguage(), {
          month: 'long',
          year: 'numeric',
        })}
      </Title>
      <CalNavButton
        aria-label="Previous Month"
        sx={{
          'marginLeft': '10px',
          'marginRight': '4px',
          '&.MuiIconButton-sizeMedium': {
            'boxSizing': 'border-box',
          },
        }}
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        {/* wrap icon component in div to fix safari icon issue */}
        <SvgIcon fontSize="inherit" component={() => (<div><ChevronLeftSmallOutlined /></div>)} inheritViewBox />
      </CalNavButton>

      <CalNavButton
        aria-label="Next Month"
        sx={{
          'marginRight': '14px',
          'position': 'relative',
          '&.MuiIconButton-sizeMedium': {
            'boxSizing': 'border-box',
          },
        }}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled || disableNextMonth}
      >
        {/* wrap icon component in div to fix safari icon issue */}
        <SvgIcon fontSize="inherit" component={() => (<div><ChevronRightSmallOutlined /></div>)} inheritViewBox />
        {!nextMonthButtonDisabled && disableNextMonth &&
        <Backdrop
          sx={{
            position: 'absolute',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
          }}
          open={true}
        >
          <CircularProgress color="inherit" size={10} sx={{
            position: 'absolute',
            top: 'calc(50% - .125*10px)',
          }} />
        </Backdrop>
        }
      </CalNavButton>
    </CalNavHeader>
  );
}
